import { render, staticRenderFns } from "./RatioCard.vue?vue&type=template&id=6b63138a&scoped=true"
import script from "./RatioCard.vue?vue&type=script&lang=js"
export * from "./RatioCard.vue?vue&type=script&lang=js"
import style0 from "./RatioCard.vue?vue&type=style&index=0&id=6b63138a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63138a",
  null
  
)

export default component.exports